import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "9f7ec452-9144-4ddd-9f65-cefbedc0f1c6", content: "Tambourine", options: {} },
  { id: "42e1ee57-1ab2-407e-816c-a55a5a57068f", content: "Double bass", options: {} },
  { id: "1eb74c84-65fd-4af1-9bb2-b54294eee9d5", content: "Electric guitar", options: {} },
  { id: "9a749bdf-4769-47fa-afbd-23a30485c851", content: "Violin", options: {} },
  { id: "6e6e7566-c4da-495c-a168-c4ad17bb495f", content: "Small pipe organ", options: {} },
  { id: "913bbaf7-edf5-4a72-bbbf-aeb637151a85", content: "Timpani", options: {} },
];

const groups = [
  { id: "251df10f-aa7b-443a-8e03-86be0c23544f", content: "Uses effect of missing fundamental ", options: {} },
  { id: "a8d345f6-ea46-492a-a808-be801a537f04", content: "Does not use the missing fundamental", options: {} },
];

export const task: Task = {
  id: "8f97f466-31c3-42b1-b947-7d8759e0100e",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
    multipleConnection: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "251df10f-aa7b-443a-8e03-86be0c23544f",
      itemsId: [
        "9a749bdf-4769-47fa-afbd-23a30485c851",
        "6e6e7566-c4da-495c-a168-c4ad17bb495f",
        "913bbaf7-edf5-4a72-bbbf-aeb637151a85",
      ],
    },
    {
      groupId: "a8d345f6-ea46-492a-a808-be801a537f04",
      itemsId: [
        "9f7ec452-9144-4ddd-9f65-cefbedc0f1c6",
        "42e1ee57-1ab2-407e-816c-a55a5a57068f",
        "1eb74c84-65fd-4af1-9bb2-b54294eee9d5",
      ],
    },
  ],
};
